(function setupChatPos() {
  const stickyEl = document.querySelector(".main-product .product-actions");
  
  function positionWidgets() {
    const widgetEl = document.querySelector("#shopify-chat");
    const stickyCartEl = document.querySelector(".sticky-cart-toggle");
    const stickyElHeight = stickyEl.getBoundingClientRect().height;
    const widgetBottom = stickyElHeight + 10;

    if (widgetEl) {
      widgetEl.style.setProperty("--chat-bottom", `${widgetBottom}px`);
      widgetEl.classList.add("positioned");
    }

    if (stickyCartEl) {
      stickyCartEl.style.setProperty("--chat-bottom", `${widgetBottom}px`);
      stickyCartEl.classList.add("positioned");
    }

    
  }

  function handleResize() {
    positionWidgets();
  }
  
  window.addEventListener("load", function () {
    positionWidgets();
  });

  new ResizeObserver(handleResize).observe(stickyEl)
})();
